/**
 * Block serialization utilities for MarthaEditor
 * Extracted from BlockNoteEditor.tsx
 */

import type { BlockNoteEditor as BlockNoteEditorCore } from '@blocknote/core';

/**
 * Serialize editor content as BlockNote JSON.
 * ~100x faster to load than markdown for large documents because
 * it avoids the expensive tryParseMarkdownToBlocks() call on reload.
 */
export function blocksToJSON(editor: BlockNoteEditorCore): string {
  try {
    return JSON.stringify(editor.document);
  } catch (error) {
    console.error('Failed to serialize blocks:', error);
    return '[]';
  }
}

/**
 * Convert BlockNote blocks to markdown (used for export/getMarkdown).
 */
export async function blocksToMarkdown(editor: BlockNoteEditorCore): Promise<string> {
  try {
    const markdown = await editor.blocksToMarkdownLossy(editor.document);
    // Clean up consecutive backslash-only lines (empty paragraph markers)
    // that accumulate over save cycles, causing massive whitespace gaps
    return markdown.replace(/(\\\n){2,}/g, '\n');
  } catch (error) {
    console.error('Failed to convert to markdown:', error);
    return '';
  }
}
